import { OnInit, AfterViewInit } from "@angular/core";
import { Component, Input } from "@angular/core";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { BrandsServiceService } from "src/app/Services/brands-service.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "app-brands-carousel",
    templateUrl: "./brands-carousel.component.html",
    styleUrls: ["./brands-carousel.component.scss"],
})
export class BrandsCarouselComponent implements OnInit, AfterViewInit {
    public config: SwiperConfigInterface = {};
    lang: any;
    brandsList: any;
    SwiperConfig: any = {};
    brandTypeData = {
        isSlider: "",
        isSqure: "",
    };
    environmentVariables: any;
    constructor(
        public embryoService: EmbryoService,
        private translate: TranslateService,
        private router: Router,
        private brandsService: BrandsServiceService,
        private confgServ: StaticPagesService
    ) {
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
    }
    ngOnInit() {
        this.getBrandsData();
        this.getInitilizingData();
    }

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.brandTypeData.isSlider =
                this.environmentVariables.BRANDS_STYLE;
            this.brandTypeData.isSqure = this.environmentVariables.BRANDS_CARD;
            // console.log(this.brandTypeData);
        });
    }

    getBrandsData() {
        this.brandsService.getHomeBrands().subscribe((res: any) => {
            if (res.code == 200) {
                this.brandsList = res?.data;
                this.embryoService.sendBrands(res?.data);
            }
        });
    }
    redirectToBrand(data: any) {
        if (data?.has_images)
            this.router.navigate([`/${this.lang}/brand`, data?.id]);
        else
            this.router.navigate([`/${this.lang}/products`], {
                queryParams: { brand_id: data?.id, page: 1 },
            });
    }
    ngAfterViewInit() {
        this.SwiperConfig = {
            slidesPerView: 7,
            spaceBetween: 16,
            keyboard: true,
            navigation: true,
            pagination: false,
            grabCursor: true,
            loop: true,
            preloadImages: false,
            lazy: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            speed: 500,
            effect: "slide",
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                480: {
                    slidesPerView: 2,
                },
                600: {
                    slidesPerView: 3,
                },
                960: {
                    slidesPerView: 4,
                },
                1280: {
                    slidesPerView: 6,
                },
                1500: {
                    slidesPerView: 7,
                },
            },
        };
    }
}
